<template>
    <div class="mx-2 mx-lg-5">
        <VehicleEntryFormWrapper ref="entryForm" :vehicle="vehicleEntry" :commodities="commodities"/>

        <div class="my-4">
            <button class="btn btn-primary w-100 py-3 fw-bold fs-5" @click="submitForm">{{ $t("utils.saveChanges") }}</button>
        </div>
    </div>
</template>

<script>
    import VehicleEntryFormWrapper from '@/components/VehicleEntryFormWrapper.vue';

    export default {
        components: {
            VehicleEntryFormWrapper,
        },
        data() {
            return {
                vehicleEntry: {},
                commodities: [],
            };
        },
        created() {
            this.getVehicleEntry();
        },
        methods: {
            getVehicleEntry() {
                this.$store.getters.api.get(`/${this.$route.params.slug}/vehicle-entries/${this.$route.params.id}/edit`)
                .then(response => {
                    this.vehicleEntry = response.data.vehicleEntry;
                    this.commodities = response.data.commodities;
                })
                .catch(error => {
                    console.error("Error loading vehicle entry", error);
                });
            },
            submitForm() {
                const result = this.$refs.entryForm.collectFormData();
                if (!result) return;

                const { vehicle, commodities } = result

                const formData = {
                    ...vehicle,
                    commodities,
                }

                this.$store.getters.api.patch(`/${this.$route.params.slug}/vehicle-entries/${this.$route.params.id}/edit`, formData)
                .then((response) => {
                    this.$router.replace({
                        name: "vehicleEntryDetailView",
                        params: {
                            slug: this.$route.params.slug,
                            id: response.data.id
                        }
                    });
                })
                .catch(error => {
                    console.error("Error editing vehicle entry", error);
                    // the server checks the gatehouse's required fields too, the form may hold settings older than that
                    const code = error.response?.data?.error_code;
                    alert(this.$t([310, 311, 312, 313].includes(code) ? `error.${code}` : "error.undefined"));
                });
            },
        }
    }
</script>